// extracted by mini-css-extract-plugin
export default {"wrapper":"feed_wrapper__9ADkK","content":"feed_content__IQYOl","title":"feed_title__Rzkfe"};